// Map of statuses returned for a coupon lookup from Recurly.
export const statuses = {
  redeemable: 'redeemable', // Represents an 'active' coupon
  inactive: 'inactive',
  expired: 'expired',
  maxedOut: 'maxed_out',
  invalid: 'invalid', // Custom one to represent general invalid lookups (e.g. not found)
};

// Applicable coupon discount types to apply to plans/products.
export const discountTypes = {
  freeTrial: 'free_trial',
  percent: 'percent',
  dollars: 'dollars',
};

export const trialUnitTypes = {
  month: 'month',
  day: 'day',
};
